import React from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";

import { Label } from "..";

export function ArrayText({ value, color, ...props }) {
  if (!value?.length || (typeof value === "string" && !value.trim()))
    return null;

  return (Array.isArray(value) ? value : [value.toString().trim()]).map((o) => {
    return (
      <Label key={v4()} basic color={color} data-test="label-text" {...props}>
        {o}
      </Label>
    );
  });
}

ArrayText.propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  color: PropTypes.string,
};

ArrayText.defaultProps = {
  value: [],
  color: "grey",
};

export default ArrayText;
